// src/pages/faq/EditarPregunta.js
import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import { RichTextFieldModal } from 'components/RichText'
import { normalizarBooleano } from 'utils/general'

function EditarPregunta(props) {
	const { preguntaOriginal, mostrar, guardar, cancelar } = props

	const [datosPregunta, setDatosPregunta] = useState({
		id: null,
		pregunta: '',
		respuesta: '',
		orden: 0,
		activo: true
	})

	const [erroresValidacion, setErroresValidacion] = useState({})
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		if (preguntaOriginal && mostrar) {
			setDatosPregunta({
				id: preguntaOriginal.id,
				pregunta: preguntaOriginal.pregunta || '',
				respuesta: preguntaOriginal.respuesta || '',
				orden: preguntaOriginal.orden || 0,
				activo: normalizarBooleano(preguntaOriginal.activo)
			})
			setErroresValidacion({})
		}
	}, [preguntaOriginal, mostrar])

	const handleClose = () => {
		setDatosPregunta({
			id: null,
			pregunta: '',
			respuesta: '',
			orden: 0,
			activo: true
		})
		setErroresValidacion({})
		cancelar()
	}

	const handleChange = (value, key) => {
		setDatosPregunta(prev => ({
			...prev,
			[key]: value
		}))
	}

	const validarDatos = () => {
		const nuevosErrores = {}

		if (!datosPregunta.pregunta.trim()) {
			nuevosErrores.pregunta = 'La pregunta es requerida'
		}

		if (!datosPregunta.respuesta || datosPregunta.respuesta.trim() === '') {
			nuevosErrores.respuesta = 'La respuesta es requerida'
		}

		setErroresValidacion(nuevosErrores)
		return Object.keys(nuevosErrores).length === 0
	}

	const handleProcesar = async (e) => {
		e.preventDefault()

		if (validarDatos()) {
			setLoading(true)
			try {
				// Enviar solo los campos modificables (sin id)
				const { id, ...datosActualizados } = datosPregunta
				await guardar(datosActualizados)
				handleClose()
			} catch (error) {
				console.error(error)
			} finally {
				setLoading(false)
			}
		}
	}

	// render
	return (
		<Offcanvas show={mostrar} onHide={handleClose} placement="end" style={{ width: '60%' }}>
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Editar pregunta frecuente" />
			<Offcanvas.Body id="editar-pregunta">
				<h5 className="mb-3">Campos de la pregunta</h5>
				{datosPregunta.id && (
					<Row>
						<Col sm={12}>
							<Form onSubmit={handleProcesar}>
								<Row>
									<Col>
										<Form.Group className="mb-3" controlId="pregunta-activo">
											<Form.Check
												type="switch"
												label="Activa (visible en el sitio web)"
												checked={datosPregunta.activo}
												onChange={(e) => handleChange(e.target.checked, 'activo')}
											/>
										</Form.Group>
									</Col>
								</Row>

								<Row>
									<Col>
										<Form.Group className="mb-3" controlId="pregunta-texto">
											<FormLabel>Pregunta *</FormLabel>
											<Form.Control
												as="textarea"
												rows={3}
												value={datosPregunta.pregunta}
												onChange={(e) => handleChange(e.target.value, 'pregunta')}
												isInvalid={!!erroresValidacion.pregunta}
												placeholder="Escriba la pregunta frecuente..."
											/>
											<Form.Control.Feedback type="invalid">
												{erroresValidacion.pregunta}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>
								</Row>

								<Row>
									<Col>
										<Form.Group className="mb-3" controlId="pregunta-respuesta">
											<RichTextFieldModal
												value={datosPregunta.respuesta}
												onChange={(contenido) => handleChange(contenido, 'respuesta')}
												label="Respuesta *"
											/>
											{erroresValidacion.respuesta && (
												<div className="text-danger mt-1">
													<small>{erroresValidacion.respuesta}</small>
												</div>
											)}
										</Form.Group>
									</Col>
								</Row>

								<Row>
									<Col md={4}>
										<Form.Group className="mb-3" controlId="pregunta-orden">
											<FormLabel>Orden</FormLabel>
											<Form.Control
												type="number"
												value={datosPregunta.orden}
												onChange={(e) => handleChange(parseInt(e.target.value) || 0, 'orden')}
												min="0"
											/>
											<Form.Text className="text-muted">
												Menor número = aparece primero
											</Form.Text>
										</Form.Group>
									</Col>
								</Row>
							</Form>
						</Col>
					</Row>
				)}
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-secondary" onClick={handleClose} className="me-2" disabled={loading}>
					Cancelar
				</Button>
				<Button
					variant="primary"
					onClick={handleProcesar}
					disabled={loading}
				>
					{loading ? (
						<><i className="fa fa-spinner fa-spin me-2"></i> Guardando...</>
					) : (
						<><i className="fa fa-save me-2"></i> Guardar</>
					)}
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default EditarPregunta